"use strict";

var PropTypes = require('prop-types');

var compose = require('../../hoc/compose');

var template = require('./dockDirection.jsx');

var displayNames = require('../displayNames');

var DockItem = template;
DockItem.displayName = displayNames.DOCK_DIRECTION;
DockItem.propTypes = {
  value: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  onMouseEnter: PropTypes.func,
  onMouseLeave: PropTypes.func
};
DockItem.defaultProps = {
  disabled: false
};
module.exports = compose(DockItem);